var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1211 18.6445C12.7569 18.6445 13.2722 18.1291 13.2722 17.4933V13.2725L17.4931 13.2725C18.1289 13.2725 18.6443 12.7571 18.6443 12.1213C18.6443 11.4856 18.1289 10.9702 17.4931 10.9702H13.2722L13.2722 6.74931C13.2722 6.11355 12.7569 5.59816 12.1211 5.59816C11.4853 5.59816 10.9699 6.11355 10.9699 6.74931L10.9699 10.9702L6.74907 10.9702C6.11331 10.9702 5.59793 11.4856 5.59793 12.1213C5.59793 12.7571 6.11331 13.2725 6.74907 13.2725H10.9699V17.4933C10.9699 18.1291 11.4853 18.6445 12.1211 18.6445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.4e3890815ccf3494dce8c60d2a491e86.svg";
export { ForwardRef as ReactComponent };